import { Trans, useTranslation } from 'next-i18next';
import { useLocale } from '@/hooks';
import { DialogBody, DialogFooter, DialogHeader, ResponsiveDialog } from '@/ui_v3';
import { FEATURE_UPSELL_CONFIG, type FeatureUpsellFeature, resolveFeatureUpsellImageSrc } from './featureUpsell.config';
import { UpgradeButton } from './UpgradeButton';
import { UpsellFeatureIntro } from './UpsellFeatureIntro';
import { useUpgradeToPro } from './useUpgradeToPro';
interface Props {
  feature: FeatureUpsellFeature;
  onClose?: VoidFunction;
}
export const FeatureUpsellModal = ({
  feature,
  onClose
}: Props) => {
  const {
    t
  } = useTranslation(['build']);
  const {
    locale
  } = useLocale();
  const upgradeToPro = useUpgradeToPro();
  const config = FEATURE_UPSELL_CONFIG[feature];
  const modalTitle = t(config.modalTitleKey);
  const handleUpgrade = () => upgradeToPro('click_feature_upselling_upgrade', config.from);

  // 고정 높이 모달. DialogContent 는 flex flex-col 이므로, 이 모달에 한해
  // 헤더/푸터를 shrink-0 으로 고정하고 본문을 flex-1 min-h-0 로 스크롤시킨다.
  // (전역 dialog 프리미티브는 건드리지 않고 여기서만 국소 적용)
  return <ResponsiveDialog onClose={onClose} size="lg" className="max-mobile-lg:!h-[calc(90dvh-env(safe-area-inset-top))] mobile-lg:!h-[642px] mobile-lg:!w-[540px]" data-sentry-element="ResponsiveDialog" data-sentry-component="FeatureUpsellModal" data-sentry-source-file="FeatureUpsellModal.tsx">
      <DialogHeader className="shrink-0" title={modalTitle} hasCloseButton onClose={onClose} data-sentry-element="DialogHeader" data-sentry-source-file="FeatureUpsellModal.tsx" />
      <DialogBody className="h-auto min-h-0 flex-1 overflow-y-scroll [scrollbar-gutter:stable]" data-sentry-element="DialogBody" data-sentry-source-file="FeatureUpsellModal.tsx">
        <UpsellFeatureIntro imageSrc={resolveFeatureUpsellImageSrc(config.images, locale)} imageAlt={modalTitle} title={<Trans t={t} i18nKey={config.titleKey} components={{
        br: <br />,
        Strong: <strong className="text-strong" />
      }} />} description={t(config.descriptionKey)} notices={config.noticeKeys.map(key => t(key))} footnote={config.footnoteKey ? t(config.footnoteKey) : undefined} data-sentry-element="UpsellFeatureIntro" data-sentry-source-file="FeatureUpsellModal.tsx" />
      </DialogBody>
      <DialogFooter className="shrink-0 px-lg pb-lg pt-xs mobile-lg:px-lg mobile-lg:pb-lg mobile-lg:pt-xs" data-sentry-element="DialogFooter" data-sentry-source-file="FeatureUpsellModal.tsx">
        <UpgradeButton onClick={handleUpgrade} data-sentry-element="UpgradeButton" data-sentry-source-file="FeatureUpsellModal.tsx" />
      </DialogFooter>
    </ResponsiveDialog>;
};